import {StyledRadio} from './_styled'

export const Radio = ({checked, disabled, ...props}) => {
  const handleChange = event => {
    if (disabled) return
    if (props?.onChange) props.onChange(event)
  }

  return (
    <StyledRadio {...props} data-checked={checked} data-disabled={disabled}>
      <input
        {...props}
        className="radio__input"
        type="radio"
        checked={checked}
        onChange={handleChange}
      />
    </StyledRadio>
  )
}
